import { a } from "../internals/add-to-unscopables.js";
a("flatMap");